import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';

type Props = Readonly<{
  onDeleteClick: () => void;
  onMoveClick: () => void;
  selectedCount: number;
}>;

export const FilesGroupActions = ({
  onDeleteClick,
  onMoveClick,
  selectedCount,
}: Props) =>
  selectedCount > 0 ? (
    <>
      <Button
        onClick={onMoveClick}
        size="small"
        startIcon={<DriveFileMoveIcon />}
        sx={{ mr: 1 }}
      >
        {`Déplacer (${selectedCount.toFixed()})`}
      </Button>
      <Button
        color="error"
        onClick={onDeleteClick}
        size="small"
        startIcon={<DeleteIcon />}
        sx={{ mr: 1 }}
      >
        {`Supprimer (${selectedCount.toFixed()})`}
      </Button>
    </>
  ) : null;
